<template>
    <site-img
        v-if="list && list.length > 0"
        class="md-featured-area layout11 mg-bg"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgColor
        }"
    >
        <div class="featured-area-container">
            <site-title
                class="featured-area-title f-col"
                :title="title"
                v-animated="textAnimation"
            />

            <div
                v-if="!isMobileSize"
                class="featured-area-div"
                :class="'len' + list.length"
            >
                <a
                    class="featured-area-item"
                    v-for="(item, index) in list"
                    :key="item.url + index"
                    :href="item.url"
                    rel="noopener noreferrer"
                >
                    <img-box
                        class="featured-area-item-preview"
                        :src="featureImage(item)"
                        dir="height"
                    />
                    <div
                        class="featured-area-item-img-mask"
                        v-if="maskOption.showMask"
                        :style="{
                            backgroundColor: maskOption.maskColor
                        }"
                    ></div>
                    <div class="featured-area-item-bottom">
                        <site-title
                            class="featured-area-item-sub-title"
                            :size="24"
                            :mbSize="20"
                            :title="$ft.first(item.displayName)"
                            align="center"
                        />
                        <div
                            class="featured-area-item-tag-wrap"
                            v-if="item?.tagList?.length > 0"
                        >
                            <span v-for="tag in item.tagList" :key="tag">
                                {{ tag }}
                            </span>
                        </div>
                    </div>
                </a>
            </div>

            <swiper
                v-else
                class="featured-area-div"
                :class="'len' + list.length"
                v-bind="swiperOptions"
            >
                <slide v-for="(item, index) in list" :key="item.url + index">
                    <a
                        class="featured-area-item"
                        :href="item.url"
                        rel="noopener noreferrer"
                    >
                        <img-box
                            class="featured-area-item-preview"
                            :src="featureImage(item)"
                            dir="height"
                        />
                        <div
                            class="featured-area-item-img-mask"
                            :style="{
                                backgroundColor: maskOption.maskColor
                            }"
                        ></div>
                        <div class="featured-area-item-bottom">
                            <site-title
                                class="featured-area-item-sub-title"
                                :size="24"
                                :mbSize="18"
                                :title="$ft.first(item.displayName)"
                                align="center"
                            />
                            <div
                                class="featured-area-item-tag-wrap"
                                v-if="item?.tagList?.length > 0"
                            >
                                <span v-for="tag in item.tagList" :key="tag">
                                    {{ tag }}
                                </span>
                            </div>
                        </div>
                    </a>
                </slide>
            </swiper>
        </div>
    </site-img>
</template>

<script>
import common from '../index.js';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import { mapActions } from '@/store/helpers';
import { SET_LIST } from '../_store/types';
export default {
    mixins: [common],
    data() {
        return {
            noFetch: true
        }
    },
    computed: {
        swiperOptions() {
            if (!this.isMobileSize) {
                return; 
            }
            const obj = {
                spaceBetween: 10,
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                loop: false,
                centeredSlides: true,
                centeredSlidesBounds: true,
            };
            return fixSwiperOptions(obj);
        },
    },
    created() {
        this.setList(this.similarFeatureArea || []);
    },
    methods: {
        ...mapActions({
            setList: SET_LIST
        }),
        featureImage(item) {
            let img = this.isMobile ? item.backPicMobile : item.backPic;
            return img || this.defaultImgSrc;
        },
    },
    components: {
        Swiper,
        Slide: SwiperSlide
    },
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-featured-area.layout11 {

    .featured-area-title {
        margin-bottom: 40px;
        @include media-600 {
            margin-bottom: 20px;
        }
    }

    .featured-area-div {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        &.len1, &.len2 {
           justify-content: center; 
        }

        .featured-area-item {
            display: block;
            width: calc((100% - 40px) / 3);
            height: 370px;
            position: relative;
            overflow: hidden;

            .featured-area-item-preview {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }
            }
            .default-wrap {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(218, 218, 218, 0.2);
                img {
                    width: 64px;
                    height: 56px;
                    object-fit: contain;
                    opacity: 0.3;
                }
                @include media-600 {
                    img {
                        width: 50px;
                        height: 44px;
                    }
                }
            }
            .featured-area-item-img-mask {
                position: absolute;
                z-index: 10;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
            }
            .featured-area-item-bottom {
                width: 100%;
                padding: 30px 20px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                z-index: 20;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                @include media-600 {
                    padding: 20px;
                }
                .featured-area-item-sub-title {
                    width: 100%;
                    font-family: var(--font-medium);
                    color: #fff;
                    font-weight: 400;
                    line-height: 36px;
                    transition: all 0.3s ease;
                    @include ellipsis;
                    @include media-600 {
                        line-height: 30px;
                    }
                }
                .featured-area-item-tag-wrap {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    row-gap: 10px;
                    padding-top: 30px;
                    opacity: 0;
                    transition: all 0.3s ease;
                    transform: translateY(190px);
                    position: absolute;
                    > span {
                        display: block;
                        font-size: 14px;
                        line-height: 17px;
                        font-weight: 400;
                        color: #fff;
                    }
                }
            }
            &:hover {
                .featured-area-item-preview {
                    .img-content {
                        img {
                            transform: scale(1.1);
                        }
                    }
                }
                .featured-area-item-bottom {
                    .featured-area-item-sub-title {
                        padding-bottom: 30px;
                        border-bottom: 1px solid rgba(218, 218, 218, 0.5);
                    }
                    .featured-area-item-tag-wrap {
                        opacity: 1;
                        position: static;
                        transform: translateY(0);
                    }
                }
            }
        }

        @include media-800 {
            display: block;
            .swiper-slide {
                width: 335px;
                height: 265px;
                &:first-child {
                    margin-left: 15px;
                }

                .featured-area-item {
                    width: 100%;
                    height: 100%;

                    .featured-area-item-bottom {
                        .featured-area-item-tag-wrap {
                            margin-top: 15px;
                            padding-top: 15px;
                            border-top: 1px solid rgba(218, 218, 218, 0.5);
                            opacity: 1;
                            position: static;
                            transform: translateY(0);
                        }
                    }
                    &:hover {
                        .featured-area-item-sub-title {
                            padding-bottom: 0;
                            border-bottom: none;
                        }
                    }
                }
            }

            &.len1 {
                .swiper-wrapper {
                    justify-content: center;
                }
                .swiper-slide {
                    &:first-child {
                        margin-left: 0;
                        margin-right: 0 !important;
                    }
                }
            }
        }
    }
}
</style>
